<template>
  <div class="search_w bc_F2F2F2">
    <div class="site_content">

      <SiteBreadcrumb />

      <div class="main_w">
        <!-- 项目列表 -->
        <ProjectList  :list="queryResult.list">
          <template #inner>
            <TradeItem
              v-for="item in queryResult.list"
              :key="item.id"
              :data="item"
              @click.native="onGoProjectItem(item.projectNo)"
            />
          </template>
        </ProjectList>
      </div>

      <div class="d_flex justify_content_c" style="padding: 21px 0">
        <!--分页-->
        <MyPagination
          :current-page="queryResult.pageNum"
          :total="queryResult.total"
          style="margin-top: 8px"
          change-method-name="getDataList"
          :that="this"
          layout="total,sizes, prev, pager, next, jumper"
          :pageInfo="pageInfo"
          :pageSizes="[16]"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { search_auctions,portal_project_tradingHall } from "@/api/portal";
import ProjectList from '@/components/template/ProjectList.vue'
import AuctionItem from "@/components/template/otherTradeKind/AuctionItem.vue";
import MyPagination from "@/components/base/MyPagination.vue";
import TradeItem from "@/components/template/otherTradeKind/TradeItem.vue";
import SiteBreadcrumb from '@/components/base/SiteBreadcrumb.vue'

export default {
  components: {
    AuctionItem,
    MyPagination,
    ProjectList,
    TradeItem,
    SiteBreadcrumb
  },
  data() {
    return {
      queryResult: { list: [] },
      pageInfo: {
        page: 1,
        rows: 16,
      },
    };
  },
  computed:{
    keyword(){
      return this.$route.query.wd
    }
  },
  async created() {
    this.getDataList();
  },
  methods: {
    // 获取数据
    async getDataList() {
      const { data } = await portal_project_tradingHall({ title: this.keyword,...this.pageInfo });

      if (!data) return;
      this.queryResult = data;
    },

    //前往项目详情 click
    onGoProjectItem(projectNo) {
      this.$router.push({
        name: "tradeDetail",
        query: {
          projectNo,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.search_w {
  .empty_w {
    min-height: 200px;
    margin: 50px auto;
  }
}
</style>
